import { Suspense } from 'react';
import { Layout } from 'modules/minimal-ui-theme';
import {
  LazyDeleteReasonErrorAlert,
  LazyDeleteReasonModal
} from 'modules/modals';
import { ReasonDetails, ReasonPageHeader } from 'modules/reason';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const ReasonDetailsPage = () => {
  const { isEnabled } = useFeatureToggle(
    FeatureFlag.IS_DEVIATION_DETAILS_PAGE_ENABLED
  );

  if (!isEnabled) return null;

  return (
    <Layout header={<ReasonPageHeader />} withFooter>
      <ReasonDetails />
      <Suspense>
        <LazyDeleteReasonModal />
        <LazyDeleteReasonErrorAlert />
      </Suspense>
    </Layout>
  );
};
